import { OverlayModule } from '@angular/cdk/overlay';
import { inject, NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Route, RouterModule, RouterStateSnapshot } from '@angular/router';
import { AuthGuardService } from '@libs/shared/auth';
import { CapabilityService } from '@libs/shared/services';
import { FOOTER_PAGE_ROUTE_PATHS, PAGE_ROOT_PATHS } from '@libs/shared/models';
import { ContentPageComponent } from './components';

export const pageAuthGuardFn: CanActivateFn = (snapshot: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const capabilityService: CapabilityService = inject(CapabilityService);
  const authGuardService: AuthGuardService = inject(AuthGuardService);

  return capabilityService.isAvailable('platform.cmsAppConfigMode')()
    ? true
    : authGuardService.canActivate(snapshot, state);
};

export const createContentRoutes = (pageRootPaths: readonly string[]): Route[] => [
  ...pageRootPaths.map(path => ({
    path,
    children: [
      {
        path: '**',
        canActivate: [pageAuthGuardFn],
        component: ContentPageComponent,
      },
    ],
  } satisfies Route)),
];

export const contentRoutes: Route[] = createContentRoutes(PAGE_ROOT_PATHS);

export const footerRoutes: Route[] = [
  ...FOOTER_PAGE_ROUTE_PATHS.map(path => ({
    path,
    component: ContentPageComponent,
    pathMatch: 'full',
  } satisfies Route)),
];

@NgModule({
  imports: [
    OverlayModule,
    RouterModule.forChild([...contentRoutes, ...footerRoutes]),
    ContentPageComponent,
  ],
  exports: [
    ContentPageComponent,
  ],
})
export class ContentPageModule {
}
